import { MainLangType } from 'types/mainPage';

export const getMainUrl = (lang: MainLangType) => {
  switch (lang) {
    case 'en':
      return '../eng.html';
    case 'by':
      return '../bel.html';
    case 'ru':
      return '/';
    default: {
      return '/';
    }
  }
};
